import { WebPlugin } from '@capacitor/core';
export class ResgridWeb extends WebPlugin {
    async start(options) {
        throw new Error('Not implemented on web: ' + options.url);
    }
    async stop() {
        throw new Error('Not implemented on web: ');
    }
    async showModal() {
        throw new Error('Not implemented on web: ');
    }
    async checkPermissions() {
        throw this.unimplemented('Not implemented on web.');
    }
    async requestPermissions() {
        throw this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map